import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "mb-3" }

import { ref, onMounted, defineAsyncComponent } from "vue";
import { useRoute, useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import apiService from "@/services/apiService";


export default /*@__PURE__*/_defineComponent({
  __name: 'KnowlegeCategoryEdit',
  setup(__props) {

const Card1 = defineAsyncComponent(
  () => import("@/components/commen/card/cardData1.vue")
);

const BlogCategoryForm = defineAsyncComponent(
  () => import("@/components/theme/admin/knowlege/BlogCategoryForm.vue")
);

const route = useRoute();
const router = useRouter();

// State
const category = ref<any>(null);
const loading = ref(false);
const isEdit = ref(false);

// Methods
const fetchCategory = async (id: string) => {
  try {
    loading.value = true;
    category.value = await apiService.getKnowledgeCategoryById(id);
  } catch (error) {
    console.error("Error fetching category:", error);
    toast.error("Failed to load category");
    router.push("/admin/knowlege-categories");
  } finally {
    loading.value = false;
  }
};

const handleSave = async (categoryData: any) => {
  try {
    loading.value = true;

    if (isEdit.value && route.params.id) {
      await apiService.updateKnowledgeCategory(
        route.params.id as string,
        categoryData
      );
      toast.success("Category updated successfully");
    } else {
      await apiService.createKnowledgeCategory(categoryData);
      toast.success("Category created successfully");
    }

    router.push("/admin/knowlege-categories");
  } catch (error: any) {
    console.error("Error saving category:", error);
    toast.error(error.response?.data?.message || "Failed to save category");
  } finally {
    loading.value = false;
  }
};

const handleCancel = () => {
  router.push("/admin/knowlege-categories");
};

// Lifecycle
onMounted(async () => {
  const categoryId = route.params.id as string;

  if (categoryId && categoryId !== "new") {
    isEdit.value = true;
    await fetchCategory(categoryId);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Breadcrumbs, {
      title: 
        isEdit.value ? `Edit Category: ${category.value?.title || ''}` : 'Create Category'
      
    }, null, 8, ["title"]),
    _createVNode(_unref(Card1), {
      colClass: "col-sm-12",
      cardhaderClass: "pb-0 title-header",
      title: isEdit.value ? 'Edit Knowledge Category' : 'Create Knowledge Category'
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: "/knowledge-categories",
                class: "btn btn-outline-secondary"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "fa fa-arrow-left me-2" }, null, -1),
                  _createTextVNode("Back to Categories ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createVNode(_unref(BlogCategoryForm), {
              category: category.value,
              "is-edit": isEdit.value,
              loading: loading.value,
              onSave: handleSave,
              onCancel: handleCancel
            }, null, 8, ["category", "is-edit", "loading"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})